var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 55,
    viewBox: "0 0 97 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5288 21V34.3082C16.5288 36.8533 14.5419 38.9166 12.0908 38.9166H1",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 53.6411V27.6621",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.533 25.9297C18.8615 25.9297 20.7491 23.9696 20.7491 21.5518C20.7491 19.1339 18.8615 17.1738 16.533 17.1738C14.2045 17.1738 12.3169 19.1339 12.3169 21.5518C12.3169 23.9696 14.2045 25.9297 16.533 25.9297Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6963 17.794L43.6259 16.6615C43.034 16.4968 42.4256 16.8615 42.267 17.4761L40.7298 23.4334C40.5712 24.048 40.9225 24.6797 41.5143 24.8444L45.5848 25.9769C46.1766 26.1416 46.785 25.7769 46.9436 25.1623L48.4809 19.205C48.6394 18.5904 48.2882 17.9587 47.6963 17.794Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10655 1.85421C6.26516 1.23955 6.87352 0.87485 7.46537 1.03955L51.1769 13.2016C51.9929 13.4286 52.2749 14.4816 51.689 15.1135L40.1468 27.5614C39.8666 27.8635 39.4505 27.9836 39.0604 27.8751L3.12094 17.8755C2.52909 17.7108 2.17787 17.0791 2.33639 16.4645L6.10655 1.85421Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3755 16.6851L4.16211 9.3916",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 13.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0002 35.8008C82.0002 35.8008 88.6668 32.8008 88.6668 28.3008V23.0508L82.0002 20.8008L75.3335 23.0508V28.3008C75.3335 32.8008 82.0002 35.8008 82.0002 35.8008Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3332 26.1992L80.7498 30.3242L78.6665 28.4492",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon8);
export default __webpack_public_path__ + "static/media/faq-icon8.52827c57e22e402b74122bf1e7642fe2.svg";
export { ForwardRef as ReactComponent };